import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
} from '@mui/material';
import FilledButton from './FilledButton';
import OutlinedButton from './OutlinedButton';

const ActionReasonDialog = ({ open, onClose, title, reasons = [], onConfirm }) => {
  const [reason, setReason] = useState('');
  const [otherText, setOtherText] = useState('');

  useEffect(() => {
    if (open) {
      setReason('');
      setOtherText('');
    }
  }, [open]);

  const handleConfirm = () => {
    if (!reason) return;
    const finalReason = reason === 'other' ? otherText.trim() : reason;
    if (reason === 'other' && !finalReason) return;
    onConfirm(finalReason);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <RadioGroup value={reason} onChange={(e) => setReason(e.target.value)}>
          {reasons.map(([val, label]) => (
            <FormControlLabel key={val} value={val} control={<Radio />} label={label} />
          ))}
          <FormControlLabel value="other" control={<Radio />} label="Other (specify reason)" />
        </RadioGroup>
        {reason === 'other' && (
          <TextField
            autoFocus
            margin="dense"
            fullWidth
            multiline
            minRows={3}
            value={otherText}
            onChange={(e) => setOtherText(e.target.value)}
            sx={{ mt: 2 }}
          />
        )}
      </DialogContent>
      <DialogActions>
        <OutlinedButton onClick={onClose} text="Cancel" color="success" />
        <FilledButton
          onClick={handleConfirm}
          disabled={!reason || (reason === 'other' && !otherText.trim())}
          text="Confirm"
          color="success"
        />
      </DialogActions>
    </Dialog>
  );
};

export default ActionReasonDialog;
